/* Pre-footer featured-on strip: 48px vertical, border-top, inside the 1280px narcis container. */
.strip {
  max-width: 1280px;
  margin: 0 auto;
  padding: 48px 0;
  border-top: 1px solid var(--border);
  text-align: center;
}

.label {
  display: block;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 18px;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.badge {
  height: 40px;
  width: auto;
  opacity: 0.7;
  transition: opacity 0.15s ease;

  &:hover { opacity: 1; }
}
